import { render, staticRenderFns } from "./OrderAdminChat.vue?vue&type=template&id=69aef232&lang=pug"
import script from "./OrderAdminChat.vue?vue&type=script&lang=js"
export * from "./OrderAdminChat.vue?vue&type=script&lang=js"
import style0 from "./OrderAdminChat.vue?vue&type=style&index=0&id=69aef232&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports